// packages/compose/src/hooks/use-isomorphic-layout-effect/index.js
import { useEffect, useLayoutEffect } from "@wordpress/element";
var useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;
var use_isomorphic_layout_effect_default = useIsomorphicLayoutEffect;
export {
  use_isomorphic_layout_effect_default as default
};
//# sourceMappingURL=index.js.map
